import React from 'react';

interface Props {
  onHover: boolean;
}

const Logout = ({ onHover }: Props) => {
  return (
    <>
      {onHover ? (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" fill="#F4F2F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3 15.2C16.0083 15.2 15.7285 15.3159 15.5222 15.5222C15.3159 15.7285 15.2 16.0083 15.2 16.3V31.7C15.2 31.9917 15.3159 32.2715 15.5222 32.4778C15.7285 32.6841 16.0083 32.8 16.3 32.8H20.7C21.3075 32.8 21.8 33.2925 21.8 33.9C21.8 34.5075 21.3075 35 20.7 35H16.3C15.4248 35 14.5854 34.6523 13.9665 34.0335C13.3477 33.4146 13 32.5752 13 31.7V16.3C13 15.4248 13.3477 14.5854 13.9665 13.9665C14.5854 13.3477 15.4248 13 16.3 13H20.7C21.3075 13 21.8 13.4925 21.8 14.1C21.8 14.7075 21.3075 15.2 20.7 15.2H16.3Z"
            fill="#6D46DD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.6222 17.7222C28.0518 17.2926 28.7482 17.2926 29.1778 17.7222L34.6778 23.2222C35.1074 23.6518 35.1074 24.3482 34.6778 24.7778L29.1778 30.2778C28.7482 30.7074 28.0518 30.7074 27.6222 30.2778C27.1926 29.8482 27.1926 29.1518 27.6222 28.7222L32.3444 24L27.6222 19.2778C27.1926 18.8482 27.1926 18.1518 27.6222 17.7222Z"
            fill="#6D46DD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.6 24C19.6 23.3925 20.0925 22.9 20.7 22.9H33.9C34.5075 22.9 35 23.3925 35 24C35 24.6075 34.5075 25.1 33.9 25.1H20.7C20.0925 25.1 19.6 24.6075 19.6 24Z"
            fill="#6D46DD"
          />
        </svg>
      ) : (
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="48"
            height="48"
            transform="translate(0 1)"
            fill="#525067"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3 16.2C16.0083 16.2 15.7285 16.3159 15.5222 16.5222C15.3159 16.7285 15.2 17.0083 15.2 17.3V32.7C15.2 32.9917 15.3159 33.2715 15.5222 33.4778C15.7285 33.6841 16.0083 33.8 16.3 33.8H20.7C21.3075 33.8 21.8 34.2925 21.8 34.9C21.8 35.5075 21.3075 36 20.7 36H16.3C15.4248 36 14.5854 35.6523 13.9665 35.0335C13.3477 34.4146 13 33.5752 13 32.7V17.3C13 16.4248 13.3477 15.5854 13.9665 14.9665C14.5854 14.3477 15.4248 14 16.3 14H20.7C21.3075 14 21.8 14.4925 21.8 15.1C21.8 15.7075 21.3075 16.2 20.7 16.2H16.3Z"
            fill="#F4F2F9"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.6222 18.7222C28.0518 18.2926 28.7482 18.2926 29.1778 18.7222L34.6778 24.2222C35.1074 24.6518 35.1074 25.3482 34.6778 25.7778L29.1778 31.2778C28.7482 31.7074 28.0518 31.7074 27.6222 31.2778C27.1926 30.8482 27.1926 30.1518 27.6222 29.7222L32.3444 25L27.6222 20.2778C27.1926 19.8482 27.1926 19.1518 27.6222 18.7222Z"
            fill="#F4F2F9"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.6 25C19.6 24.3925 20.0925 23.9 20.7 23.9H33.9C34.5075 23.9 35 24.3925 35 25C35 25.6075 34.5075 26.1 33.9 26.1H20.7C20.0925 26.1 19.6 25.6075 19.6 25Z"
            fill="#F4F2F9"
          />
        </svg>
      )}
    </>
  );
};

export default Logout;
